import { render, staticRenderFns } from "./Patrocinio.vue?vue&type=template&id=1041f8e6&"
import script from "./Patrocinio.vue?vue&type=script&lang=js&"
export * from "./Patrocinio.vue?vue&type=script&lang=js&"
import style0 from "./Patrocinio.vue?vue&type=style&index=0&id=1041f8e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports